export default "__VITE_ASSET__20f2b874__"